<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
    <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center">Mi Comercio</h1></div>
  </div>

  <div class="row-cols-12 m-2">
    <div class="text-p p-3">
      <div class="col file fileuploadphoto text-center">
        @if (!preview_img_avatar()) {
          <img src="./assets/img/user-init.png" style="width:80px" class="text-end rounded-circle business-profile">
        } @else {
          <img [src]="preview_img_avatar()" style="width:80px" class="text-end rounded-circle business-profile imagen-preview" (click)="openModal()">
        }

        <input type="file" #profileimage class="form-control" id="profileimage" style="display: none;" (change)="capturarFileImgAvatar()">
        <label class="changeimage" (click)="capturarFileImgAvatar()">cambiar</label>
      </div>
    </div>
  </div>

  <!-- Modal Preview IMG PERFIL -->
  <div class="modal fade" id="modalPreviewImg" tabindex="-1" role="dialog" aria-labelledby="modalPreviewImgLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalPreviewImgLabel">Foto Perfil</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img [src]="preview_img_avatar_large()" class="img-fluid">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        <form (ngSubmit)="saveUsuario()" [formGroup]="form">

          <div class="row mt-4">
            <label for="razon_social" class="form-label">Razón Social <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="razon_social" formControlName="razon_social">
          </div>
          @if (form.controls.razon_social.touched && form.controls.razon_social.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">La razón social es requerida</small></div>
          }

          <div class="row mt-4">
            <label for="nombre_fantasia" class="form-label">Nombre Fantasía <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="nombre_fantasia" formControlName="nombre_fantasia">
          </div>
          @if (form.controls.nombre_fantasia.touched && form.controls.nombre_fantasia.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">El nombre fantasía es requerido</small></div>
          }

          <div class="row mt-4">
            <div class="col ps-0 pe-0">
              <label for="tipo_documento" class="form-label">Tipo <span class="text-danger">*</span></label>
              <select class="form-control" name="tipo_documento" formControlName="tipo_documento" (change)="actualizarMascara()">
                @for (td of tiposDocs(); track td.id) {
                  <option [ngValue]="td.id">{{ td.x_descripcion }}</option>
                }
              </select>
            </div>
            <div class="col ps-2 pe-0">
              <label for="nro_documento" class="form-label">Nro Documento <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="nro_documento" formControlName="nro_documento" [showMaskTyped]="true" [mask]="maskDocumento()">
            </div>
          </div>

          @if (form.controls.tipo_documento.touched && form.controls.tipo_documento.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">El Tipo de Documento es requerido</small></div>
          }

          @if (form.controls.nro_documento.touched && form.controls.nro_documento.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">Ingrese un Nro. de Documento válido</small></div>
          }

          @if (form.controls.nro_documento.touched && form.controls.nro_documento.errors?.['maxlength']) {
            <div class="alert-danger" role="alert"><small class="alert">El número de documento no puede tener más de 13 caracteres.</small></div>
          }

          <div class="row mt-4">
            <label for="nro_habilitacion" class="form-label">Nro de habilitación <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="nro_habilitacion" formControlName="nro_habilitacion">
          </div>
          @if (form.controls.nro_habilitacion.touched && form.controls.nro_habilitacion.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">Ingrese un Nro. de habilitación válido</small></div>
          }

          <div class="row mt-4">
            <label for="responsable_comercial" class="form-label">Responsable Técnico / Comercial <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="responsable_comercial" formControlName="responsable_comercial">
          </div>
          @if (form.controls.responsable_comercial.touched && form.controls.responsable_comercial.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">El responsable técnico / comercial es requerido</small></div>
          }

          <div class="row mt-4">
            <div class="align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
              <label class="form-check-label col col-sm-4 pe-5" for="mercadopago">Acepta MercadoPago</label>
              <input class="form-check-input ms-3" type="checkbox" id="mercadopago" formControlName="mercadopago">
            </div>
          </div>

          <div class="row mt-4">
            <div class="align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
              <label class="form-check-label col col-sm-4 pe-5" for="envios">Realiza envíos</label>
              <input class="form-check-input ms-3" type="checkbox" id="envios" formControlName="envios">
            </div>
          </div>

          <div class="row mt-4">
            <div class="align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
              <label class="form-check-label col col-sm-4 pe-5" for="vende_medicamentos">Vende medicamentos</label>
              <input class="form-check-input ms-3" type="checkbox" id="vende_medicamentos" formControlName="vende_medicamentos">
            </div>
          </div>

          <div class="row mt-4">
            <label for="porcentaje_descuento_medicamentos" class="form-label"><b>% de descuento</b> en medicamentos <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="porcentaje_descuento_medicamentos"
              formControlName="porcentaje_descuento_medicamentos"
              [mask]="'separator.2'"
              [suffix]="'%'"
              [dropSpecialCharacters]="true"
              [thousandSeparator]="''"
              [decimalMarker]="'.'"
              placeholder="0.00%">
          </div>

          @if (form.controls.porcentaje_descuento_medicamentos.touched && form.controls.porcentaje_descuento_medicamentos.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">Ingrese un % de descuento válido</small></div>
          }
          @if (form.controls.porcentaje_descuento_medicamentos.touched && (form.controls.porcentaje_descuento_medicamentos.errors?.['min'] || form.controls.porcentaje_descuento_medicamentos.errors?.['max'])) {
            <div class="alert-danger" role="alert"><small class="alert">El % debe estar entre 0 y 100</small></div>
          }

          <div class="row mt-4">
            <small class="text-muted p-0">(*) Libre Salud le cobrará {{ porcentaje_comision_libresalud() }}% de comisión sobre las ventas.</small>
          </div>

          @if (error()) {
            <div class="alert alert-danger mt-2" role="alert">
              <small>{{ error() }}</small>
            </div>
          }

          <div class="d-grid mt-4 mb-3 pb-3">
            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading() || form.disabled">
              {{ loading() ? 'Cargando...' : 'Actualizar mis datos' }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
